<template>
  <div style="min-width: 1400px" class="wrapper">
    <HomeHeader></HomeHeader>
    <router-view></router-view>
    <HomeFooter> </HomeFooter>
  </div>
</template>

<script>
import { createNamespacedHelpers } from "vuex";
const { mapMutations: userMutations, mapState: userState } =
  createNamespacedHelpers("user");
import HomeHeader from "../components/home/HomeHeader";
import HomeFooter from "../components/home/HomeFooter";

export default {
  components: {
    HomeHeader,
    HomeFooter,
  },
  mounted() {
    this.handleFlag()
  },
  methods: {
    ...userMutations(['handleIsNav']),
    handleFlag() {
     this.handleIsNav(false)
    },
  },
};
</script>

<style lang="scss" scoped>
$primaryColor: #ea5b24;
$secondaryColor: #525c66;
$tertiaryColor: #8f8e8c;
.master_wrapper {
  height: 100%;
  width: 100%;
  padding-top: 40px;
  background-color: $tertiaryColor;
  > div {
    background-color: white;
    min-width: 1400px;
    padding: 20px 0px;
  }
}
</style>